export default "assets/images/icons/slider_arrow_gray-b68f3337.svg";